<template>
  <div class="micro-pie">
    <svg ref="svg" :width="size.width" :height="size.height"><defs /></svg>
    <Transition name="fade">
      <div v-if="tooltip" class="tooltip" :style="fixedTooltip || {top: tooltip.top, left: tooltip.left, transform: tooltip.transform}">
        <!-- <div class="value">{{ tooltip.count }} </div> -->
        <div class="value">{{ (tooltip.count/data.count*100).toFixed(0) }}% </div>
        <div class="label"> {{ tooltip.label }}</div>
      </div>
    </Transition>
  </div>
</template>

<script>
import {select as d3_select} from 'd3-selection'
import {arc as d3_arc, pie as d3_pie} from 'd3-shape'

import {bcnColors} from '@/utils/colorUtils'

import Size from '@/mixins/Size'
export default {
  
  mixins:[Size],
  props: ['data','fixedTooltip'],
  data(){
    return {
      tooltip: null
    }
  },
  watch:{
    size(){
      this.drawChart()
    }
  },
  mounted() {
    this.drawChart()
  },
  methods:{
    drawChart(){
      if(!this.data) return
      let width = this.size.width
      let height = this.size.height
      let radius = Math.min(width,height)/2
      let pieData = d3_pie().sort(null).value(d => d.count)(this.data.values);
      let pie = d3_arc().padAngle(0.05).innerRadius(radius-15).outerRadius(radius)
      let root = d3_select(this.$refs.svg).selectAll('.root').data([null])
      root = root.merge(root.enter().append('g').attr('class','root'))
      
      let items = root.selectAll('.item').data(pieData,(d)=>d.data.label)
      let itemsEnter = items.enter().append('g').attr('class','item')
      itemsEnter.append('path').attr('fill',(d,i)=>bcnColors[i])
      items = items.merge(itemsEnter)
      items.select('path').attr('d', pie)
      items.on('mouseenter',(e,d)=>{
        // this.tooltip = d.data
        this.tooltip = {...d.data, top: height/2+'px',left:width/2+'px',transform: 'translate(-50%,-50%)'}
        items.classed('active',(dd)=>dd.data===d.data).classed('innactive',(dd)=>dd.data!==d.data)
      })
      items.on('mouseleave',()=>{
        this.tooltip=null
        items.classed('active',false).classed('innactive',false)
      })
      root.attr('transform',`translate(${width/2},${height/2})`)
      
    }
  }
}
</script>

<style lang="stylus" scoped>
.micro-pie
  display flex
  width 100%
  height 100%
  
</style>
